import React, { useCallback, useEffect, useState } from "react";
import styles from "./addUsers.module.css";
import { Tabs, Tab, Divider, Box, Typography } from "@mui/material";
import { useLocation, useSearchParams } from "react-router-dom";
import UserTable from "./UserTable";
import NewUserModal from "./NewUserModal";
import NewUserPopup from "./NewUserModal/NewUserModal";
import Notification from "./SuccessNotification/Notification";

const BASE_URL = "http://localhost:5050"; // ✅ update if needed
const STATUS_BY_TAB = ["pending", "expired", "rejected"];

const AddUsers = () => {
  const [tabValue, setTabValue] = useState(0);
  const location = useLocation();
  const [vPage, setVPage] = useState(0);
  const [title, setTitle] = useState(tabValue);
  const [data, setData] = useState([]);
  const [latest, setLatest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [vRpp, setVRpp] = useState(5);
  const [flag, setFlag] = useState(false);
  const [popup, setPopup] = useState(false);
  const [searchParams] = useSearchParams();
  const [newUser, setNewUser] = useState(true);
  const [newUser1, setNewUser1] = useState(true);
  const [refreshData, setRefreshData] = useState(false);
  const companyId = searchParams.get("company_id");
  const phNo = searchParams.get("ph_no");
  const aid = searchParams.get("aid");
  const banner = searchParams.get("banner");
  const [open, setOpen] = useState(false);
  // read tab from URL (?tab=3)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const v = Number(params.get("tab"));
    setTabValue(Number.isFinite(v) ? v : 0);
  }, [location.search]);

  // title by tab
  useEffect(() => {
    if (tabValue === 0) setTitle("Pending Kyc List");
    if (tabValue === 1) setTitle("Expired Kyc List");
    if (tabValue === 2) setTitle("Rejected Kyc List");
  }, [tabValue]);

  // 🔥 FETCH KYC DATA by user_id and filter by tab/status
  useEffect(() => {
    const user_id = "98aee9ac-fc44-46df-80b3-e1310553636f";
    if (!user_id) {
      // no user_id → clear table gracefully
      setData([]);
      setLoading(false);
      return;
    }

    const controller = new AbortController();
    setLoading(true);

    fetch(`${BASE_URL}/api/user_kyc`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id }),
      signal: controller.signal,
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(
            `Fetch failed (${res.status}): ${text || res.statusText}`
          );
        }
        return res.json();
      })
      .then((json) => {
        const all = Array.isArray(json?.data) ? json.data : [];
        const want = STATUS_BY_TAB[tabValue]; // "pending" | "expired" | "rejected"
        const filtered = all.filter(
          (r) => (r?.status || "pending").toLowerCase() === want
        );
        setData(filtered);
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("Load user_kyc error:", err);
          setData([]); // show empty state on error
        }
      })
      .finally(() => setLoading(false));

    // refetch when tab changes, URL changes (user_id/tab query), or modal closes
    return () => controller.abort();
  }, [tabValue, location.search, flag, popup, refreshData]);

  useEffect(() => {
    setPopup(banner);
  }, [banner]);

  const onAddNewUsersClick = useCallback(() => {
    setFlag(true);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.welcomesunshineinfotech}>
        <button className={styles.addNewUsers} onClick={onAddNewUsersClick}>
          <img className={styles.plusCircleIcon} alt="" src="/pluscircle.svg" />
          <b className={styles.newUser}>New user</b>
        </button>
      </div>

      <Tabs
        value={tabValue}
        onChange={(_, newValue) => setTabValue(newValue)}
        variant="scrollable"
        slotProps={{
          indicator: { sx: { backgroundColor: "#2348AB" } },
        }}
      >
        {["Pending", "Expired", "Rejected"].map((label) => (
          <Tab
            key={label}
            label={label}
            classes={{ root: styles.tabRoot, selected: styles.tabSelected }}
            sx={{ "&.Mui-selected": { color: "#2348AB" } }}
          />
        ))}
      </Tabs>

      <Divider style={{ marginBottom: "15px" }} />

      {/* Pass loading if your UserTable supports it; otherwise it will just render data */}
      <UserTable
        data={data}
        title={title}
        loading={loading}
        setRefreshData={setRefreshData}
      />

      {(popup || flag) && (
        <div
          className={styles.newUsersOverlay}
          onClick={() => {
            setFlag(false);
          }}
        >
          <NewUserModal
            isVisible={flag || popup}
            onClose={() => {
              setFlag(false);
              setPopup(false);
            }}
            setOpen={setOpen}
            // If NewUserModal can call this after saving, the table will refresh instantly
            onSaved={() => setPopup((p) => !p)} // toggles dependency to refetch
          />
        </div>
      )}
      {banner && (
        <NewUserPopup
          isOpen={newUser || newUser1}
          showGuideCard={newUser1}
          showWelcomeCard={newUser}
          onCloseGuide={() => setNewUser1(false)} // close only the first
          onCloseWelcome={() => setNewUser(false)} // close only the second
          onOverlayClose={() => {
            // optional: overlay closes both
            setNewUser(false);
            setNewUser1(false);
          }}
          onProceed={() => {
            // navigate("/advanced-kyc");
            setNewUser(false);
            setNewUser1(false);
          }}
          mascotSrc="/images/cupi-mascot.png"
        />
      )}
      {<Notification open={open} onClose={() => setOpen(false)} />}
    </div>
  );
};

export default AddUsers;
